"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _index = require("./index");
var _reducers = require("../sharedState/reducers");
var _syncLocalStorage = _interopRequireDefault(require("../sharedState/syncLocalStorage"));
var composeEnhancers = typeof window !== 'undefined' &&
// eslint-disable-next-line no-underscore-dangle
window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _index.compose;
var getDefaultEnhancers = function getDefaultEnhancers(middlewares, persistSharedState) {
  if (middlewares === void 0) {
    middlewares = [];
  }
  if (persistSharedState === void 0) {
    persistSharedState = false;
  }
  var middleware = [_reduxThunk.default].concat(middlewares);
  if (persistSharedState) {
    middleware.push((0, _syncLocalStorage.default)({
      keys: Object.keys(_reducers.reducers)
    }));
  }
  return [_index.applyMiddleware.apply(void 0, middleware)];
};
var configureStore = function configureStore(// $FlowFixMe: add annotations
_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    reducers = _ref.reducers,
    _ref$middlewares = _ref.middlewares,
    middlewares = _ref$middlewares === void 0 ? [] : _ref$middlewares,
    _ref$initialState = _ref.initialState,
    initialState = _ref$initialState === void 0 ? {} : _ref$initialState,
    _ref$getEnhancers = _ref.getEnhancers,
    getEnhancers = _ref$getEnhancers === void 0 ? getDefaultEnhancers : _ref$getEnhancers,
    _ref$persistSharedSta = _ref.persistSharedState,
    persistSharedState = _ref$persistSharedSta === void 0 ? false : _ref$persistSharedSta;
  return (0, _index.createStore)(typeof reducers !== 'function' ? (0, _index.combineReducers)(reducers) : reducers, initialState, composeEnhancers.apply(void 0, getEnhancers(middlewares, persistSharedState)));
};
var _default = exports.default = configureStore;